import { render } from "./proximamenteScreen.vue?vue&type=template&id=cdbf103a&scoped=true"
import script from "./proximamenteScreen.vue?vue&type=script&lang=js"
export * from "./proximamenteScreen.vue?vue&type=script&lang=js"

import "./proximamenteScreen.vue?vue&type=style&index=0&id=cdbf103a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbf103a"]])

export default __exports__